export default __webpack_public_path__ + "static/logo-ed3d4a1564fbf54cea5d82c6780888c7.png";